var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":("https://app.moskitcrm.com/?/deal/" + _vm.moskit),"target":"_blank"}},[_c('b-img',{attrs:{"src":_vm.moskitIcon,"width":"24px"}}),_vm._v(" Abrir no Moskit ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }